/* eslint-disable import/prefer-default-export */
import { View } from '@src/utils/graph.helpers'
import type { UsageInfo } from '@src/endpoints/services/commonHdr.service'
import type { Graph } from '@src/components/vis.js.network.vis/models'

// Reducer
export const defaultState = {
  graph: {} as Graph,
  isPending: false,
  isPendingGraph: true,
  selectedGraphView: View.access,
  usageBy: null as number | null,
  usageList: [] as UsageInfo[],
  errors: null as any,
  parsePolicyNames: false
}

export type AccessGraphState = typeof defaultState
